<template>
	<v-row justify="center">
		<v-col cols="12" class="py-0">
			<v-row justify="center" align="stretch">
				<!-- Results -->
				<v-col cols="12" md="4" class="d-flex flex-column">
					<v-img contain width="350" class="banner align-self-center" :src="images.banner"> </v-img>
					<v-card id="next-drawing-card">
						<div class="card-header"><span>Drawing</span></div>
						<upcoming-sortition
							id="upcoming-result"
							:upcoming-sortition="upcomingSortition"
							@refresh="fetchUpcomingSortition"
						>
						</upcoming-sortition>
						<div class="d-flex justify-content-center align-content-center">
							<v-img
								:src="images.blueStar"
								contain
								height="35"
								width="35"
								class="animate-left"
							/>
							<h1 id="winning-numbers-text" class="align-self-center">
								WINNING NUMBERS
							</h1>
							<v-img
								:src="images.blueStar"
								contain
								height="35"
								width="35"
								class="animate-right"
							/>
						</div>
						<result-display
							v-for="result in results.entries.slice(0, 1)"
							:key="result.sortition.id"
							:result="result"
						>
							<br />
						</result-display>
					</v-card>
				</v-col>
				<!-- Next Drawing -->
				<v-col
					v-if="results.entries.slice(1).length > 0"
					md="4"
					class="d-flex flex-column"
				>
					<v-card id="results-card" class="pt-0">
						<div class="card-header"><span>Numbers</span><span>Pick</span></div>
						<result-display
							v-for="result in results.entries.slice(1)"
							:key="result.sortition.id"
							:result="result"
						>
						</result-display>
					</v-card>
				</v-col>
				<!-- Payouts -->
				<v-col md="4" class="d-flex flex-column">
					<!-- Playouts card -->
					<v-img contain width="350" class="banner align-self-center" :src="images.bannerRight"> </v-img>
					<v-card id="playouts-card">
						<div class="card-header">
							<span v-if="showPrizes"> Payouts </span>
							<span v-else> Results </span>
						</div>
						<prizes-card v-if="showPrizes" :prizes="prizes"></prizes-card>
						<results-card
							class="card-results"
							v-if="showResults"
							:results-by-lottery="resultsToShow"
							display-horizontally
						></results-card>
					</v-card>
				</v-col>
			</v-row>
		</v-col>
		<v-col id="page-url" cols="12" class="text-center py-0">
			<span>Visit our page {{ url }}</span>
		</v-col>
	</v-row>
</template>

<script>
import ResultDisplay from './ResultDisplay.vue';
import UpcomingSortition from './UpcomingSortition.vue';
import BaseBoard from '../BaseBoard.js';
import PrizesCard from './PrizesCard.vue';
import blueStar from 'assets/static/img/extras/fastplay/blue_star.png';
import banner from 'assets/static/img/logo/fastplay_left.png';
import bannerRight from 'assets/static/img/logo/fastplay_right.png';
import ResultsCard from '../../common/ResultsCard.vue';

export default {
	name: 'Board',
	extends: BaseBoard,
	data: () => {
		return {
			images: {
				blueStar,
				banner,
				bannerRight
			}
		};
	},
	components: {
		ResultsCard,
		UpcomingSortition,
		ResultDisplay,
		PrizesCard
	}
};
</script>

<style scoped lang="scss">
@import 'css/variables';
@import 'css/animations';

$card-background: rgba($white, 0.5);

::v-deep .card-results * {
	color: black;
}

* .result-display:not(:last-child) {
	margin-bottom: 0;
}

.v-card {
	background-color: darken($card-background, 2);
	color: $white;
	border-radius: 30px;

	&:not(#primary-card) {
		box-shadow: 8px 6px 20px 0 #07000080;
	}
}

#primary-card {
	background-color: transparent;
	border: 2px solid $white;
}

::v-deep .v-card #countdown {
	line-height: 40px;
	text-align: center;
	font-family: 'Made Tommy Bold', serif;
}

#winning-numbers-text {
	line-height: 20px;
	color: $red;
	font-size: 1.6rem;
}

#upcoming-sortition {
	margin-top: 10px;
	margin-bottom: 10px;
}

.card-header {
	box-shadow: 0 6px 20px 4px #2c14f563;
	font-size: 1.3rem;
	padding: 0 6px;
	margin-bottom: 10px;
	display: flex;
	flex-direction: row;
	justify-content: space-around;
	width: 100%;
	background-image: linear-gradient(to right, $dark-blue, $blue, $dark-blue);
}

.v-card > *:first-child:not(.v-btn):not(.v-chip),
.v-card > .v-card__progress + *:not(.v-btn):not(.v-chip) {
	border-top-left-radius: 30px;
	border-top-right-radius: 30px;
}

#next-drawing-card,
#playouts-card {
	height: 100%;
}

#next-drawing-card,
#results-card,
#playouts-card {
	border-top-right-radius: 30px;
	border-top-left-radius: 30px;
}

.winning-number-star {
	display: inline-block;
	justify-content: center;
	align-content: center;
	vertical-align: middle;
}

.animate-right {
	animation: rotateStar;
	animation-iteration-count: infinite;
	animation-duration: 2s;
	animation-timing-function: linear;
	animation-fill-mode: forwards;
}

.animate-left {
	animation: rotateStar;
	animation-iteration-count: infinite;
	animation-duration: 2s;
	animation-timing-function: linear;
	animation-fill-mode: forwards;
	animation-direction: reverse;
}

#page-url span {
	font-size: 2rem;
	font-family: 'Arial';
	font-weight: bold;
	text-transform: uppercase;
	color: #1354e2;
}
</style>
